/**
 * Scroll the dashboard's main scroll container (and the window) back to the top
 * whenever `deps` change. Used so that opening any new entry/detail/wizard view
 * always starts from the top instead of inheriting the previous scroll offset.
 *
 * It fires immediately, again on the next animation frame, and once more after a
 * short delay so late layout shifts (images, toasts, async content) can't leave
 * the view parked mid-page.
 */
import { useEffect } from 'react';

export function useScrollToTop(deps: ReadonlyArray<unknown>): void {
  useEffect(() => {
    const toTop = () => {
      document.querySelector('main.app-scroll')?.scrollTo({ top: 0, left: 0 });
      if (typeof window !== 'undefined') window.scrollTo({ top: 0, left: 0 });
    };
    toTop();
    const raf = requestAnimationFrame(toTop);
    const t = window.setTimeout(toTop, 80);
    return () => {
      cancelAnimationFrame(raf);
      window.clearTimeout(t);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
